export const isRelative = (url) => url.indexOf('..') !== -1 || url[0] === '.' || url[0] !== '/'


const urlSegment = (name, val) => `${name}=${encodeURIComponent(val)}`
const arrayToUrl = (name, array) => array.map((val) => urlSegment(`${name}[]`, val)).join('&')

export const objectToUrl = (obj) =>
  Object.entries(obj)
    .map(([key, val]) => {
      if (Array.isArray(val)) {
        return arrayToUrl(key, val)
      }
      return urlSegment(key, val)
    })
    .join('&')

export const getParamFromUrl = (param, url = document.location.search) => {
  const searchParams = new URLSearchParams(url)
  return searchParams.get(param)
}
